module.exports = __webpack_public_path__ + "img/zuijia_09.b7562280.png";